import { BUILD_ID_FALLBACK } from './constants';

export function removeLastSlash(str = '') {
  return str.replace(/\/$/, '');
}

// App build ID - need to stay || because build ID can be empty string and then we need to use fallback
export const BuildID = process.env.NX_PUBLIC_BUILD_ID || BUILD_ID_FALLBACK;
// NN api url
const ApiUrl = process.env.NX_PUBLIC_API_URL ?? '';
if (!ApiUrl) {
  throw new Error('Api URL not defined!');
}
// api version - need to stay || because API version can be empty string and then we need to use fallback
const ApiAppVersion = process.env.NX_PUBLIC_API_VERSION || '3.0.0';
// base path to assets on S3
const AssetsBaseUrl = removeLastSlash(process.env.NX_PUBLIC_ASSETS_URL);
// base url to SSO
const AuthBaseUrl = removeLastSlash(process.env.NX_PUBLIC_AUTH_URL);
// login url
const LoginUrl = `${AuthBaseUrl}/opxp/login/?theme=opxp`;
const RegistrationUrl = `${AuthBaseUrl}/opxp/signup/?theme=opxp`;
const LogoutUrl = `${AuthBaseUrl}/logout/?theme=opxp`;
// debug flag
const IsDebug = !!process.env.NX_PUBLIC_DEBUG;
// base url to locales bucket on S3
const LocalesBaseUrl = removeLastSlash(process.env.NX_PUBLIC_LOCALES_URL);
// base url to checkout
const CheckoutUrl = removeLastSlash(process.env.NX_PUBLIC_CHECKOUT_URL);
// base url to training app
const TrainingAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_TRAINING_URL);
// url to onboarding app
const OnboardingAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_ONBOARDING_URL);
// url to user app
const UserAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_USER_URL);
// url to social app
const SocialAppPath = removeLastSlash(process.env.NX_PUBLIC_OPXP_SOCIAL_URL);
// url to neuronation blog
const BlogPath = removeLastSlash(process.env.NX_PUBLIC_BLOG_URL);

//project base path
const BasePath = process.env.NX_PUBLIC_BASE_PATH ?? process.env.NX_PUBLIC_URL ?? '/';

const PrivacyPolicyUrl = `${OnboardingAppPath}/legals/dataprivacy`;
//remoteConfig name
const RemoteConfigSubscribe = process.env.NX_PUBLIC_REMOTE_CONFIG_SUBSCRIBE ?? 'productweb_dev';
const RestoreSubscriptionRemoteConfig =
  process.env.NX_PUBLIC_REMOTE_CONFIG_RESTORE_PRODUCTS ?? 'restore_subscription_products_dev';
const RemoteConfigOnboardingFlow = process.env.NX_PUBLIC_REMOTE_CONFIG_ONBOARDING_FLOW ?? 'onboarding_flow_dev';
const RemoteConfigCorporateProducts = process.env.NX_PUBLIC_REMOTE_CONFIG_CORP_PRODUCTS ?? 'productweb_corporate_dev';

const FirebaseConfig =
  process.env.NODE_ENV === 'test'
    ? {
        apiKey: 'mock-api-key',
        authDomain: 'mock-auth-domain',
        databaseURL: 'mock-database-url',
        projectId: 'mock-project-id',
        storageBucket: 'mock-storage-bucket',
        messagingSenderId: 'mock-messaging-sender-id',
        appId: 'mock-app-id',
        measurementId: 'mock-measurement-id',
      }
    : {
        apiKey: process.env.NX_PUBLIC_FIREBASE_API_KEY ?? '',
        authDomain: process.env.NX_PUBLIC_FIREBASE_DOMAIN,
        databaseURL: process.env.NX_PUBLIC_FIREBASE_URL,
        projectId: process.env.NX_PUBLIC_FIREBASE_PROJECT_ID ?? '',
        storageBucket: process.env.NX_PUBLIC_FIREBASE_BUCKET,
        messagingSenderId: process.env.NX_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
        appId: process.env.NX_PUBLIC_FIREBASE_APP_ID ?? '',
        measurementId: process.env.NX_PUBLIC_FIREBASE_MEASUREMENT_ID ?? '',
      };

const ENV = {
  ApiUrl,
  ApiAppVersion,
  AssetsBaseUrl,
  AuthBaseUrl,
  LoginUrl,
  LogoutUrl,
  RegistrationUrl,
  IsDebug,
  LocalesBaseUrl,
  CheckoutUrl,
  TrainingAppPath,
  OnboardingAppPath,
  UserAppPath,
  SocialAppPath,
  BlogPath,
  BasePath,
  PrivacyPolicyUrl,
  RemoteConfigSubscribe,
  RestoreSubscriptionRemoteConfig,
  RemoteConfigOnboardingFlow,
  RemoteConfigCorporateProducts,
  FirebaseConfig,
};

export default ENV;
